var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mouseover":_vm.onHover,"mouseleave":_vm.onLeave}},[_c('ToggleButton',{key:_vm.componentKey,attrs:{"labels":{ checked: _vm.checkedLabel, unchecked: _vm.uncheckedLabel },"width":_vm.width,"height":_vm.height,"color":_vm.color},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }